import React, { Component } from 'react';
import { Card, Icon, Avatar, message, Input } from 'antd';
import { Redirect } from 'react-router-dom';
import PublicMenu from '../../components/TopMenu';
import FavButton from '../../components/FavButton';
import TruckModal from '../../components/modals/TruckModal';
import axios from 'axios';
import Configuration from '../../Configuration';
const { Meta } = Card;
const Search = Input.Search;

class Trucks extends Component {
  constructor() {
    super();
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.schema = {plates: '', reference: ''};
    this.state = {redirect: false, trucks: [], filteredTrucks: [], modalVisible: false, current: this.schema, handleSave: this.handleCreate};
    this.validateToken = this.validateToken.bind(this);
    this.handleStatus = this.handleStatus.bind(this);
    this.getTrucks = this.getTrucks.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  componentDidMount() {
    this.validateToken();
    this.getTrucks();
  }

  validateToken() {
    if(!localStorage.getItem('visitapp:token'))
      this.setState({redirect: true});
    
    if(!Configuration.isInRol(localStorage.getItem('visitapp:rol'), "admin or manager"))
      this.setState({redirect: true});
  }

  getTrucks() {
    axios.get(`${Configuration.apiServer}/api/v1/trucks`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')
      
      this.setState({trucks: resp.data, filteredTrucks: resp.data});
    });
  }

  handleStatus(id) {
    axios.put(`${Configuration.apiServer}/api/v1/trucks/${id}/status`, {}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      message.success('Registro actualizado')
      this.getTrucks();
    });
  }

  handleSearch(event) {
    const trucks = this.state.trucks.filter(truck => {
      return truck.name.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1
    });

    this.setState({filteredTrucks: trucks});
  }

  handleOpenModal(kind, record) {
    if(kind === 'new') {
      this.setState({modalVisible: true, current: this.schema, handleSave: this.handleCreate});
    } else {
      this.setState({modalVisible: true, current: record, handleSave: this.handleUpdate});
    }
  }

  handleCloseModal() {
    this.setState({modalVisible: false});
  }

  handleCreate(record) {
    axios.post(`${Configuration.apiServer}/api/v1/trucks`, {truck: record}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getTrucks();
      this.setState({modalVisible: false});
      message.success('Registro guardado');
    });
  }

  handleUpdate(record) {
    axios.put(`${Configuration.apiServer}/api/v1/trucks/${this.state.current.id}`, {truck: record}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getTrucks();
      this.setState({modalVisible: false});
      message.success('Registro actualizado');
    });
  }
  
  render() {
    // Verify authentication
    if(this.state.redirect) {
      return (
        <Redirect to="/" />
      );
    }

    // List of trucks
    const trucks = this.state.filteredTrucks.map(truck => {
      return (
        <Card
          style={{ width: '24%', margin: '10px 0px' }}
          actions={[<Icon type="eye" style={{ color: '#ccc' }} />, <Icon type="edit" onClick={() => { this.handleOpenModal('edit', truck) }} />]}
          key={truck.id}
        >
          <Meta
            avatar={<Avatar icon="car" />}
            title={truck.plates}
            description={<span className={`cursor text-${Configuration.getStatus(truck.status).color}`} onClick={() => { this.handleStatus(truck.id) }}>{Configuration.getStatus(truck.status).text}</span>}
          />
          <p className="text-muted" style={{ marginBottom: '0px', marginLeft: '45px', marginTop: '5px' }}>Referencia {truck.reference}</p>
        </Card>
      );
    });

    // Render component
    return (
      <div>
        <PublicMenu />
        
        <div className="container" style={{ marginTop: '30px' }}>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="text-primary" style={{ marginBottom: '0px' }}>Camiones</h3>
            <Search placeholder="Buscar..." onChange={this.handleSearch} style={{ width: '30%' }} />
          </div>

          <br/>

          <div className="d-flex flex-row flex-wrap justify-content-between">
            {trucks}
          </div>
        </div>

        <FavButton handleClick={this.handleOpenModal} schema={this.state.current} />

        <TruckModal visible={this.state.modalVisible} title={"Nuevo camión"} current={this.state.current} handleClose={this.handleCloseModal} handleSave={this.state.handleSave} />
      </div>
    );
  }
}

export default Trucks;



// WEBPACK FOOTER //
// ./src/pages/admin/Trucks.js